export const normalizeUrl = (
  url: string | null | undefined,
): string | undefined => {
  if (!url) {
    return undefined;
  }
  if (/^https?:\/\//i.test(url)) {
    return url;
  }
  return `https://${url}`;
};

export const stripProtocol = (url: string | null | undefined): string =>
  (url ?? '').replace(/^https?:\/\//i, '');
